import { EmailValidationHelper } from '../helpers/EmailValidationHelper';
import { Module } from '../Module';

// HACK: Better would be figuring out how to get this value passed down through scope.
export const EmailValidationSettings = {
  DEBOUNCE_MS: 350
};

Module.instance().directive('tbEmailInputValidator', [
  '$timeout',
  ($timeout: ng.ITimeoutService) => {
    let keystrokeTimeout: ng.IPromise<any>;
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: any, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        ctrl.$parsers.push((inputEmail: any) => {
          // empty string = valid
          const newValidity = !inputEmail || EmailValidationHelper.isValidEmail(inputEmail);

          if (!newValidity) {
            // Wait between keystrokes to mark as invalid
            if (EmailValidationSettings.DEBOUNCE_MS > -1) {
              keystrokeTimeout = $timeout(() => ctrl.$setValidity('email', false), EmailValidationSettings.DEBOUNCE_MS);
            } else {
              $timeout.cancel(keystrokeTimeout);
              ctrl.$setValidity('email', false);
            }
          } else {
            $timeout.cancel(keystrokeTimeout);
            ctrl.$setValidity('email', true);
          }

          return inputEmail;
        });
      }
    };
  }
]);
